import { useTranslation } from '@packlink/translation-provider';
import { TaxForm } from './TaxForm.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { CustomsSection, CustomsSectionVariant } from '../../Partials/CustomsSection.js';

function ReceiverInformationForm() {
  const {
    t
  } = useTranslation();
  return jsx(CustomsSection, {
    title: t('customs-form.tax-info.recipient-title'),
    variant: CustomsSectionVariant.SUBSECTION,
    children: jsx(TaxForm, {
      type: "receiver",
      "data-id": "customs-form-receiver-tax-form"
    })
  });
}

export { ReceiverInformationForm };
//# sourceMappingURL=ReceiverInformationForm.js.map
